var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading || !_vm.is_inited),expression:"loading || !is_inited"}],class:_vm.$style.tradingView,attrs:{"id":"trading-view"}})])}
var staticRenderFns = []

export { render, staticRenderFns }